import './KpiBar.scss';
import { ReactNode } from 'react';
import { KpiSummary } from '../category-pathing-types';
import { formatDays, formatInt } from '../utils/format';

interface KpiBarProps {
  kpis: KpiSummary;
  reportWindowLabel: string;
}

interface KpiTileProps {
  label: string;
  value: ReactNode;
  detail?: ReactNode;
}

const KpiTile = ({ label, value, detail }: KpiTileProps) => (
  <div className='kpi-tile'>
    <div className='kpi-label'>{label}</div>
    <div className='kpi-value'>{value}</div>
    {detail && <div className='kpi-detail'>{detail}</div>}
  </div>
);

export const KpiBar = ({ kpis, reportWindowLabel }: KpiBarProps) => (
  <div className='amc-kpi-bar'>
    <KpiTile
      label='New to Brand with Repurchase'
      value={formatInt(kpis.totalNtbUsers)}
      detail={reportWindowLabel}
    />
    <KpiTile
      label='Top entry category'
      value={kpis.topEntryCategory.category}
      detail={`${formatInt(kpis.topEntryCategory.users)} new to brand purchases`}
    />
    <KpiTile
      label='Top Cross-Category Repurchase'
      value={
        <span>
          {kpis.topCrossSellPair.ntbCategory}
          <span className='arrow'>{' → '}</span>
          {kpis.topCrossSellPair.followupCategory}
        </span>
      }
      detail={`${formatInt(kpis.topCrossSellPair.users)} new to brand purchases · ${formatDays(kpis.topCrossSellPair.avgDays)} to purchase`}
    />
    <KpiTile
      label='Days to Repurchase'
      value={formatDays(kpis.avgDaysToFollowup)}
      detail='Weighted average across categories'
    />
  </div>
);
